module.exports = "/_next/static/images/7bad41dc17eaf58720f8892fee8dd54d-savings-lg.jpg.webp";